import React from 'react'
import styles from './styles.module.scss'
import Avatar from '../../Avatar'

function PromptUsersModal({ users, prompt }) {
  return (
    <div className={styles.promptUserContainer}>
      {prompt && <h2 className={styles.subtitle}>{prompt.answer}</h2>}

      <div className={styles.list}>
        {users?.length > 0 &&
          users.map((user) => {
            return (
              <div key={user.id} className={styles.user}>
                <Avatar
                  showUserName={false}
                  key={'member_' + user.id}
                  userId={user.id}
                  profilePicture={user.profile_picture_data.url}
                  firstname={user.firstname}
                  lastname={user.lastname}
                  imgWrapperSize='small'
                  mimeType={user.profile_picture_data.mime_type}
                  originalTag={user.profile_picture_data.original_tag}
                  isOriginal={user.profile_picture_data.is_original}
                  status={user.status}
                  withExpertiseGroup={user.with_expertise_group}
                />
                <div className={styles.username}>{`${user.firstname} ${user.lastname}`}</div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default PromptUsersModal
